// Function to extract the first name and last initial without the period
export const extractNameParts = (
  summary: string
): { firstName: string; lastInitial: string } | null => {
  // Try pattern with parentheses first (e.g., "Skyler A. (2130 Algos)")
  const namePatternWithParen = /([A-Za-z]+)\s([A-Za-z]+)\.?\s+\(/
  let match = summary.match(namePatternWithParen)

  // If no match, try pattern without parentheses (e.g., "Sebastian L.")
  if (!match) {
    const namePatternSimple = /([A-Za-z]+)\s([A-Za-z]+)\.?$/
    match = summary.match(namePatternSimple)
  }

  if (match) {
    // Extract the first name and last initial (without the period)
    const firstName = match[1]
    const lastInitial = match[2]

    if (firstName && lastInitial) {
      return { firstName, lastInitial }
    } else {
      return null
    }
  } else {
    // return { firstName: 'Name', lastInitial: 'Not Found' }
    return null
  }
}
